module.exports = __webpack_public_path__ + "static/img/rings.c0dfc929.png";